import { DaoModel } from '@dynameat/models';

export class EventType extends DaoModel {
  constructor(guid, name, description, isPositive, color) {
    super(guid);
    this.name = name || '';
    this.description = description || '';
    this.isPositive = isPositive || false;
    this.color = color || '';
  }

  static toInstance(props = {}) {
    return new EventType(props.guid, props.name, props.description, props.is_positive, props.color);
  }

  serialize() {
    return {
      guid: this.guid,
      name: this.name,
      description: this.description,
      is_positive: this.isPositive,
      color: this.color
    };
  }
}
